module.exports = __webpack_public_path__ + "img/15.50ac86e9.jpg";